<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('raf-to-png-converter', 'Fujifilm RAF → PNG');

function handleBatchCreated(batchId: string) { console.log('[RAF to PNG] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[RAF to PNG] Job completed:', jobId); }
function handleBatchCleared() { console.log('[RAF to PNG] Batch cleared'); }
function handleError(error: Error) { console.error('[RAF to PNG] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[RAF to PNG] Credits updated:', credits); }
</script>
